import * as yup from "yup";

export const planDetailsValidation = yup.object().shape({
  name: yup.string().required("Le nom est requis"),
  identifier: yup.string().required("L'identifiant est requis"),
  pricingMode: yup.string().required("Le mode de tarification est requis"),
});

export const selectCoveragesValidation = yup.object().shape({
  insurancePlanCoverages: yup
    .array()
    .min(1, "Au moins une garantie est requise"),
});

export const configureBenefitsValidation = yup.object().shape({
  insurancePlanCoverages: yup.array().of(
    yup.object().shape({
      coverageMappings: yup
        .array()
        .min(1, "Au moins une prestation est requise"),
    }),
  ),
});

export const stepValidations = [
  planDetailsValidation,
  selectCoveragesValidation,
  configureBenefitsValidation,
  null,
];
